class ApiException extends Error {
  constructor(message, validation, additionalData) {
    super(message);

    this.validation = validation || {};
    this.additionalData = additionalData || null;
  }
}

export default ApiException;



// WEBPACK FOOTER //
// ./utils/ApiException.js